import { jsx, jsxs } from 'react/jsx-runtime';
import { useMutationCreateSubFolder } from '../../mutations/useMutationCreateSubFolder.js';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { getDefaultRadixPortalContainer } from '@fabric-app/compat';
import { noop } from 'lodash-es';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';
import { Flex } from '@fabric-app/ui/components/Flex';
import { TextInput } from '@fabric-app/ui/components/TextInput/TextInput';
import { Kbd } from '@fabric-app/ui/components/Kbd';

const ModalFolderCreate = ({ modalProps, parent, onCreate }) => {
  const mutationCreateSubfolder = useMutationCreateSubFolder();
  const formik = useFormik({
    initialValues: {
      title: ""
    },
    validationSchema: yup.object({
      title: yup.string().min(1, "Folder name is required").required("Folder name is required")
    }),
    validateOnChange: true,
    validateOnBlur: true,
    validateOnMount: true,
    onSubmit: async ({ title }, formik2) => {
      if (parent) {
        mutationCreateSubfolder.mutate({
          parent,
          folderName: title,
          action: "new-folder-modal"
        }, {
          onSuccess: (data) => {
            modalProps.onOpenChange?.(false);
            formik2.resetForm();
            onCreate?.(data);
          }
        });
      }
      formik2.setSubmitting(false);
    }
  });
  return /* @__PURE__ */ jsx(Modal.Root, {
    ...modalProps,
    open: modalProps.open && !!parent?.id,
    children: /* @__PURE__ */ jsxs(Modal.Portal, {
      container: getDefaultRadixPortalContainer(),
      children: [
        /* @__PURE__ */ jsx(Modal.Overlay, {
          style: {
            zIndex: 140
          },
          visibleOnMobileViewport: true
        }),
        /* @__PURE__ */ jsx(Modal.Content, {
          style: {
            zIndex: 141
          },
          disableMobileFullscreen: true,
          width: "xs",
          // default is no focus, we want to focus the input
          onOpenAutoFocus: noop,
          onEscapeKeyDown: (e) => {
            e.stopPropagation();
          },
          children: /* @__PURE__ */ jsx(Modal.Body, {
            children: /* @__PURE__ */ jsx("form", {
              onSubmit: formik.handleSubmit,
              children: /* @__PURE__ */ jsxs(Flex, {
                gap: "sections",
                direction: "column",
                children: [
                  /* @__PURE__ */ jsxs(Flex, {
                    gap: "sectionsShort",
                    direction: "column",
                    children: [
                      /* @__PURE__ */ jsx(Modal.Title, {
                        children: "Create folder"
                      }),
                      /* @__PURE__ */ jsx(TextInput, {
                        autoFocus: true,
                        inputHeight: "lg",
                        name: "title",
                        type: "text",
                        placeholder: "Give it a name...",
                        value: formik.values.title,
                        onChange: formik.handleChange,
                        disabled: formik.isSubmitting,
                        onBlur: formik.handleBlur,
                        tabIndex: 1
                      })
                    ]
                  }),
                  /* @__PURE__ */ jsxs(Modal.DoubleButtonContainer, {
                    children: [
                      /* @__PURE__ */ jsxs(Modal.Button, {
                        variant: "bg-secondary",
                        onClick: () => {
                          modalProps.onOpenChange?.(false);
                        },
                        children: [
                          "Cancel",
                          /* @__PURE__ */ jsx(Kbd, {
                            children: /* @__PURE__ */ jsx(Kbd.IconEsc, {})
                          })
                        ]
                      }),
                      /* @__PURE__ */ jsxs(Modal.Button, {
                        disabled: formik.isSubmitting || !formik.isValid || mutationCreateSubfolder.isPending,
                        type: "submit",
                        children: [
                          "Create",
                          /* @__PURE__ */ jsx(Kbd, {
                            children: /* @__PURE__ */ jsx(Kbd.IconEnter, {})
                          })
                        ]
                      })
                    ]
                  })
                ]
              })
            })
          })
        })
      ]
    })
  });
};

export { ModalFolderCreate };
//# sourceMappingURL=ModalCreateFolder.js.map
